// extracted by mini-css-extract-plugin
export default {"button":"ModalAddPosition_button__Wjzmp"};